import { CheckIcon } from "@/components/ui/icon";
import { Checkbox, CheckboxIndicator, CheckboxIcon, CheckboxLabel } from "@/components/ui/checkbox";
import { HStack } from "@/components/ui/hstack";
import { Input, InputField } from "@/components/ui/input";
import React from 'react';
import i18n from 'i18n-js';
import Selector from '@/components/basic/Selector'

export default function Filter({ search, setSearch, filterTitle, filters, filter, setFilter, sortTitle, sorts, sort, setSort, selectedTitle, selected, setSelected }) {
    if (!setFilter && !setSort && !setSelected) {
        return (
            <HStack space='xs' className="mx-2 mr-7 justify-between">
                <Input>
                    <InputField value={search} onChangeText={(text) => setSearch(text)} placeholder={i18n.t('searchScreen.search')} className="font-Assistant bg-secondary-50 text-md w-[290px]" />
                </Input>
            </HStack>
        );
    }

    return (
        <HStack space='xs' className="mx-2 mr-7 justify-between">
            <Input>
                <InputField value={search} onChangeText={(text) => setSearch(text)} placeholder={i18n.t('searchScreen.search')} className="font-Assistant bg-secondary-50 text-md w-[290px]" />
            </Input>
            {setSelected &&
                <Checkbox size='lg' value={i18n.t(selectedTitle)} isChecked={selected} onChange={() => setSelected(prevState => !prevState)} aria-label={i18n.t('studio.main.dontShow')} className="self-end">
                    <CheckboxLabel className="text-secondary-900 mx-2">{i18n.t(selectedTitle)}</CheckboxLabel>
                    <CheckboxIndicator className="bg-secondary-50 border-secondary-900 border">
                        <CheckboxIcon as={CheckIcon} className="bg-secondary-900" />
                    </CheckboxIndicator>
                </Checkbox>}
            <HStack space='xs'>
                <Selector title={filterTitle} selections={filters} selected={filter} setSelected={setFilter} />
                <Selector title={sortTitle} selections={sorts} selected={sort} setSelected={setSort} />
            </HStack>
        </HStack>
    );
}